module.exports = __webpack_public_path__ + "img/404.7f51a68d.svg";